export const analysisStatus = (row = {}) => String(row?.["Analysis Status"] ?? row?.analysis_status ?? row?.["Reconciliation Status"] ?? "").trim().toUpperCase();
export function isWnbaAnalysisBlocked(row = {}, sport = "") {
  if (!/^WNBA/.test(String(sport || row?.Sport || "").trim().toUpperCase())) return false;
  const status = analysisStatus(row);
  return Boolean(status && !["ANALYZED", "COMBO_ANALYZED"].includes(status));
}
export function visibleForCustomerAnalysis(row = {}, sport = "") { return !isWnbaAnalysisBlocked(row, sport); }
export const analysisBlockLabel = (row = {}) => {
  const status = analysisStatus(row);
  const combo = /\(combo\)/i.test(String(row?.["Prop Type"] ?? row?.propType ?? "")) || /\s\+\s/.test(String(row?.Player ?? ""));
  if (combo && status === "UNSUPPORTED_PROP_TYPE") return "COMBO PROP UNSUPPORTED";
  if (status.startsWith("COMBO_") && status !== "COMBO_ANALYZED") return status.replaceAll("_", " ");
  return status.replaceAll("_", " ") || "ANALYSIS UNAVAILABLE";
};
